window.bulldog = window.bulldog || {};

(function () {
  "use strict";

  bulldog.Jumplinks = function () {
    let sections = document.querySelectorAll("section[data-jumplink]");

    if (sections.length) {
      let jumplinkSection = document.querySelector(".LandingJumplinks .Container ul");
      let html = "";

      sections.forEach((el) => {
        var id = "section_" + Math.random().toString(16).slice(2);

        el.id = id;

        html += "<li>";
        html += '<a href="#' + id + '" title="">' + el.dataset.jumplink + "</a>";
        html += "</li>";
      });

      jumplinkSection.innerHTML = html;
    }
  };

  bulldog.ThreeColumn = function() {
    const swiper = new Swiper('.swiper-three-columns', {
      direction: 'horizontal',
      loop: false,
      simulateTouch: true,
      pagination: {
        el: '.swiper-pagination',
      },
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 30
          }
      }
    });
  };

  bulldog.Faq = function () {
    let answers = document.querySelectorAll(".LandingFaq .answer");

    if (answers.length) {
      answers.forEach((el) => {
        el.style.height = el.scrollHeight + 10 + "px";
      });
    }

    let questions = document.querySelectorAll(".LandingFaq .question");

    if (questions.length) {
      questions.forEach((el) => {
        el.addEventListener("click", function () {
          el.parentElement.classList.toggle("active");
        });
      });
    }
  };

  bulldog.CartAddOns = function () {
    jQuery('body').on('click', '.CartForm__AddToCart', function() {
      let button = jQuery(this);

      button.prop('disabled', true);

      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: jQuery(this).data('id')
      }, () => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:open', {
          bubbles: true
        }));

        button.prop('disabled', false);
      });
    });
  };

  bulldog.RecommendedRegime = function () {
    jQuery('body').on('click', '.RecommendedRegime__Button', function() {
      let button = jQuery(this);

      let block = button.closest('.RecommendedRegime');
      let products = block.find('.RecommendedRegime__Product');
      let productData = {
        items: []
      }

      button.prop('disabled', true);

      products.each(function() {
        let product = jQuery(this);
        let id = product.data('id');

        productData.items.push({
          quantity: 1,
          id: id
        });
      });

      jQuery.post('/cart/add.js', productData, () => {
        button.prop('disabled', false);

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:open', {
          bubbles: true
        }));
      });
    });
  };

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    const self = bulldog;

    bulldog.Jumplinks();
    bulldog.Faq();
    bulldog.CartAddOns();
    bulldog.ThreeColumn();
    bulldog.RecommendedRegime();

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
